import { defineMessages } from 'react-intl';

const translations = {
  properties: {
    sku: {
      id: 'properties.sku',
      defaultMessage: 'SKU',
      description: 'Label of the sku property',
    },
    description: {
      id: 'properties.description',
      defaultMessage: 'Description',
      description: 'Label of the description property',
    },
    quantity: {
      id: 'properties.quantity',
      defaultMessage: 'Quantity',
      description: 'Label of the quantity property',
    },
    isAvailable: {
      id: 'properties.isAvailable',
      defaultMessage: 'Available',
      description: 'Label of the is available property',
    },
    isBackorder: {
      id: 'properties.isBackorder',
      defaultMessage: 'Backorder',
      description: 'Label of the is backorder property',
    },
    claimedAt: {
      id: 'properties.claimedAt',
      defaultMessage: 'Claimed at',
      description: 'Label of the claimed at property',
    },
    isInbound: {
      id: 'properties.isInbound',
      defaultMessage: 'Inbound',
      description: 'Label of the is inbound property',
    },
    isReservation: {
      id: 'properties.isReservation',
      defaultMessage: 'Reservation',
      description: 'Label of the is reservation property',
    },
    transports: {
      id: 'properties.transports',
      defaultMessage: 'Transports',
      description: 'Label of the transports property',
    },
  },
};

export default defineMessages(translations);
